import axios from 'axios'

export default {
  /**
   * Trigger service worker skipWating so the new service worker can take over.
   * This will also trigger a window refresh (see /src/plugins/register-service-worker.js)
   */
  serviceWorkerSkipWaiting({ state, commit }) {
    if (
      state.SWRegistrationForNewContent === null ||
      state.SWRegistrationForNewContent === undefined
    )
      return

    commit('setRefreshingApp', true)
    state.SWRegistrationForNewContent.waiting.postMessage('skipWaiting')
  },
  getAvailableApplications: async ({ commit, rootState }) => {
    commit(
      'app/setLoading',
      { type: 'getAvailableApplications', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/apps`, config)
        .then(response => {
          commit('setAvailableApplications', response.data)
          commit(
            'app/setLoading',
            { type: 'getAvailableApplications', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getAvailableApplications', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  getAppIcons: async ({ commit, rootState }) => {
    commit(
      'app/setLoading',
      { type: 'getAppIcons', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/icons`, config)
        .then(response => {
          commit('setAppIcons', response.data)
          commit(
            'app/setLoading',
            { type: 'getAppIcons', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getAppIcons', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  getQuickActions: async ({ commit, rootState }) => {
    commit(
      'app/setLoading',
      { type: 'getQuickActions', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/quick-actions`, config)
        .then(response => {
          commit('setQuickActions', response.data)
          commit(
            'app/setLoading',
            { type: 'getQuickActions', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getQuickActions', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  postQuickAction: async ({ commit, rootState }, payload) => {
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/quick-actions`,
          payload.item,
          config
        )
        .then(() => {
          commit('app/setError', null, { root: true })
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: payload.this.$vuetify.lang.t(
                `$vuetify.QUICK_ACTIONS.COMMAND_SENT`
              )
            },
            { root: true }
          )
        })
    } catch (error) {
      commit('app/setError', error, { root: true })
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message: payload.this.$vuetify.lang.t(
            `$vuetify.QUICK_ACTIONS.COMMAND_FAILED`
          )
        },
        { root: true }
      )
    }
  }
}
